import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { fetchLicenseStatus } from '../../redux/slices/licenseSlice';
import LicenseScreen from './LicenseScreen';

const POLL_INTERVAL_MS = 60 * 1000;

export default function LicenseGate() {
  const dispatch = useDispatch();
  const license = useSelector((s) => s.license);

  useEffect(() => {
    dispatch(fetchLicenseStatus());
    const timer = setInterval(() => {
      dispatch(fetchLicenseStatus());
    }, POLL_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [dispatch]);

  if (license.state === 'LOADING') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-950">
        <div className="text-center">
          <div className="inline-block w-10 h-10 border-2 border-indigo-500/30 border-t-indigo-500 rounded-full animate-spin" />
          <p className="text-gray-400 text-sm mt-4">Checking license…</p>
        </div>
      </div>
    );
  }

  if (license.state === 'LOCKED' || license.state === 'UNPROVISIONED') {
    return <LicenseScreen />;
  }

  return <Outlet />;
}
